/* SUVENE Warenkorb "Complete your set": Größe wählen, "Add" legt das Gegenstück in den Warenkorb.
   Drawer: Inhalt wird neu gezeichnet (bleibt offen). /cart: Seite lädt neu. Alles per Ereignis am Dokument,
   damit es nach jedem Neuzeichnen des Drawers weiter funktioniert. */
(function () {
  if (window.__suCcs) return;
  window.__suCcs = true;
  /* Karussell: Pfeile blättern um ein Kärtchen, Wischen nativ; Pfeile am Rand deaktiviert */
  function navState(wrap) {
    var t = wrap && wrap.querySelector('[data-su-ccs-track]');
    if (!t) return;
    var p = wrap.querySelector('[data-su-ccs-prev]'), n = wrap.querySelector('[data-su-ccs-next]');
    if (p) p.disabled = t.scrollLeft < 4;
    if (n) n.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
  }
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-su-ccs-track]')) navState(e.target.closest('[data-su-ccs-wrap]'));
  }, true);
  document.addEventListener('click', function (e) {
    var arr = e.target.closest ? e.target.closest('[data-su-ccs-prev], [data-su-ccs-next]') : null;
    if (arr) {
      var wrap = arr.closest('[data-su-ccs-wrap]');
      var t = wrap.querySelector('[data-su-ccs-track]');
      var card = t.querySelector('.su-ccs__item');
      var step = card ? card.getBoundingClientRect().width + 12 : t.clientWidth;
      t.scrollBy({ left: arr.hasAttribute('data-su-ccs-next') ? step : -step, behavior: 'smooth' });
      return;
    }
    var size = e.target.closest ? e.target.closest('.su-ccs__size') : null;
    if (size) {
      var it = size.closest('[data-su-ccs]');
      it.querySelectorAll('.su-ccs__size').forEach(function (b) { b.setAttribute('aria-pressed', b === size ? 'true' : 'false'); });
      it.setAttribute('data-variant', size.getAttribute('data-variant'));
      it.querySelector('[data-su-ccs-add]').disabled = false;
      var m = it.querySelector('.su-ccs__msg'); if (m) m.hidden = true;
      return;
    }
    var add = e.target.closest ? e.target.closest('[data-su-ccs-add]') : null;
    if (!add) return;
    var item = add.closest('[data-su-ccs]');
    var id = item && item.getAttribute('data-variant');
    if (!id) return;
    var label = add.textContent;
    var msg = item.querySelector('.su-ccs__msg');
    var inDrawer = !!add.closest('cart-drawer, #CartDrawer');
    add.disabled = true;
    add.textContent = '…';
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          if (msg) { msg.textContent = data.description || data.message || msg.getAttribute('data-error') || ''; msg.hidden = false; }
          add.textContent = label; add.disabled = false;
          return;
        }
        if (inDrawer) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && data.sections) { drawer.renderContents({ sections: data.sections }, false); return; }
        }
        window.location.reload();
      })
      .catch(function () { add.textContent = label; add.disabled = false; });
  });
})();
